import api from './api'
import type {
  PublicProfile,
  UsernameAvailability,
  ProfileSettings,
  UpdateCandidateProfileRequest,
  Candidate,
} from '@/types'
import { generateUsernameSuggestions } from '@/utils/username'

export const profileService = {
  /**
   * Get public profile by username (no auth required)
   */
  async getPublicProfile(username: string): Promise<PublicProfile> {
    const response = await api.get(`/public/profiles/${username}`)
    return response.data
  },

  /**
   * Check if username is available
   */
  async checkUsernameAvailability(
    username: string
  ): Promise<UsernameAvailability> {
    const response = await api.get(`/users/username/check`, {
      params: { username },
    })
    return response.data
  },

  /**
   * Update current user's username
   */
  async updateUsername(username: string): Promise<void> {
    await api.patch('/users/me/username', { username })
  },

  /**
   * Update profile settings (theme, visibility, etc.)
   */
  async updateProfileSettings(settings: ProfileSettings): Promise<void> {
    await api.patch('/users/me/profile-settings', {
      profileSettings: settings,
    })
  },

  /**
   * Generate username suggestions from name (client-side only)
   */
  generateUsernameSuggestions(
    firstName: string,
    lastName: string
  ): string[] {
    return generateUsernameSuggestions(firstName, lastName)
  },

  /**
   * Update candidate profile (employment status, salary range)
   */
  async updateCandidateProfile(
    data: UpdateCandidateProfileRequest
  ): Promise<{ message: string; profile: Candidate }> {
    const response = await api.put('/candidates/profile', data)
    return response.data
  },
}
